<nav class="navbar navbar-expand-md navbar-light">
	<a class="title_taskmanager" routerLink="" style="text-decoration: none;">Group I (Alarm)</a>
	<mat-nav-list class="inline">
		<a mat-list-item class="navbar-brand-tool pl-3 pr-3" [routerLink]="['/home']" [ngClass]="activeBoard? 'active' : ''">
			Dashboard
		</a>
	</mat-nav-list>

	<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
		aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		<span class="navbar-toggler-icon"></span>
	</button>

	<div class="menu-group collapse navbar-collapse" id="navbarSupportedContent">
		<mat-nav-list class="inline">
			<a mat-list-item [routerLink]="['/tier-level']" [ngClass]="highlightGroupI? 'active' : '' " class="menu"
				matTooltip="Group I is a type of alarm similar to other alarms on the Alarms menu.">Tier Level</a>
			<a mat-list-item [routerLink]="['/domicile']" [ngClass]="highlightKPI? 'active' : '' " class="menu">KPI</a>
			<a mat-list-item *ngIf="isAccessible" [routerLink]="['/tier-setup']" [ngClass]="highlightMGMT? 'active' : '' " class="menu">Management</a>
			<a mat-list-item [routerLink]="['/contingency-pcs']" [ngClass]="highlightPCS? 'active' : '' " class="menu" matTooltip="Process Check Sheet">PCS</a>
		</mat-nav-list>
	</div>

</nav>